import { Box, Stack, Typography } from "@mui/material"
import { If } from "lib/@components/if"
import { Else } from "lib/@components/else"
import { buildProjectBridgeCurrentTextMarkup } from "./project-bridge-current-text-markup"

export function ProjectBridgeRewriteCardCurrentPane({ item }) {
    const currentTextMarkup = buildProjectBridgeCurrentTextMarkup(item?.currentText, item?.overlaps)

    return (
        <Stack spacing={2} sx={{ pt: 0.5 }}>
            <Typography variant="subtitle2">Current text</Typography>
            <If truthy={currentTextMarkup}>
                <Box
                    className="styled-bullets"
                    sx={{
                        minHeight: 96,
                        p: 2,
                        border: "1px solid",
                        borderColor: "divider",
                        borderRadius: 1.5,
                        fontSize: "0.875rem",
                        "& p": { mt: 0, mb: 1 },
                        "& :last-child": { mb: 0 },
                        "& mark": {
                            px: 0.25,
                            borderRadius: 0.5,
                            backgroundColor: "warning.light",
                            color: "inherit",
                        },
                    }}
                    dangerouslySetInnerHTML={{ __html: currentTextMarkup }}
                />
                <Else>
                    <Box
                        sx={{
                            minHeight: 96,
                            p: 2,
                            border: "1px solid",
                            borderColor: "divider",
                            borderRadius: 1.5,
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <Typography variant="body2" color="text.secondary">
                            No current text was available for this section.
                        </Typography>
                    </Box>
                </Else>
            </If>
        </Stack>
    )
}
